import AsyncStorage from "@react-native-async-storage/async-storage";
import React from "react";

interface User {
  token: string | null,
  mnumber: string,
  name: string
}

interface AuthState {
    user: User | undefined | null;
    status: 'idle' | 'signOut' | 'signIn' | 'loginFailure';
  }
type AuthAction = { type: 'SIGN_IN'; token: string|null, username: string, mnumber: string } | { type: 'SIGN_OUT' } | { type: 'LOGIN_FAILURE' };
type AuthPayload = string;

interface AuthContextActions {
    signIn: (data: AuthPayload) => void;
    signOut: () => void;
    loginFailure: () => void;
    loggedIn: () => boolean;
    logout: () => void;
}

interface AuthContextType extends AuthState, AuthContextActions {}
const AuthContext = React.createContext<AuthContextType>({
    status: 'idle',
    user: null,
    signIn: () => {},
    signOut: () => {},
    loginFailure: () => {},
    loggedIn: () => false,
    logout: () => {}
});

export const useAuth = (): AuthContextType => {
    const context = React.useContext(AuthContext);
    if (!context) {
      throw new Error('useAuth must be inside an AuthProvider with a value');
    }
    return context;
};

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = React.useReducer(AuthReducer, {
      status: 'idle',
      user: null,
    });
  
    React.useEffect(() => {
      const initState = async () => {
        try {
          const user = await AsyncStorage.getItem('user')
          if (user !== null) {
            const jsonUser: User = JSON.parse(user)
            dispatch({ type: 'SIGN_IN', token: jsonUser.token, username: jsonUser.name, mnumber: jsonUser.mnumber });
          } else {
          //  dispatch({ type: 'SIGN_OUT' });
          }
        } catch (e) {
          // catch error here
          // Maybe sign_out user!
        }
      };
  
      initState();
    }, []);

  
    const authActions: AuthContextActions = React.useMemo(
      () => ({
        signIn: async (token: any) => {
          await AsyncStorage.setItem('user', JSON.stringify({ token: token.token, username: token.user_display_name, mnumber: token.user_nicename }))
          dispatch({ type: 'SIGN_IN', token: token.token, username: token.user_display_name, mnumber: token.user_nicename });
          
        },
        signOut: async () => {
          dispatch({ type: 'SIGN_OUT' });
        },
        loginFailure: () => dispatch({type: 'LOGIN_FAILURE'}),
        loggedIn: () => {
          return true;
        },
        logout: async () =>{
          await AsyncStorage.removeItem('user')
          dispatch({type: 'SIGN_OUT'})
        }
      }),
      []
    );
  
    return (
      <AuthContext.Provider value={{ ...state, ...authActions }}>
        {children}
      </AuthContext.Provider>
    );
  };


  const AuthReducer = (prevState: AuthState, action: AuthAction): AuthState => {
    // console.log(`in reducer ${JSON.stringify(action)}`)

    switch (action.type) {
      case 'SIGN_IN':
        return {
          ...prevState,
          status: 'signIn',
          user: {name: action.username, mnumber: action.mnumber, token: action.token},
        };
      case 'SIGN_OUT':
        return {
          ...prevState,
          status: 'signOut',
          user: null,
        };
      case 'LOGIN_FAILURE':
          return {
            ...prevState,
            status: 'loginFailure',
            user: null,
        };
    }
  };
